import { render, staticRenderFns } from "./wipsumasday.vue?vue&type=template&id=d0cfed54&scoped=true&"
import script from "./wipsumasday.vue?vue&type=script&lang=js&"
export * from "./wipsumasday.vue?vue&type=script&lang=js&"
import style0 from "./wipsumasday.vue?vue&type=style&index=0&id=d0cfed54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cfed54",
  null
  
)

export default component.exports